import * as React from 'react';

interface Props {
  children: NonNullable<React.ReactNode>;
  /** Text labelling the form control */
  label: React.ReactNode;
  /** ID associated with the form control */
  id: string;
  icon?: React.ReactNode;
}

/**
 * Simple layout component for form inputs with text labels. Pass
 * the label text in using the `label` prop, and have your input be
 * a child of this component.
 *
 * To ensure the elements are associated, pass the same `id` prop to
 * this component as you do to the input. If you need to reference the
 * label element, for ARIA attributes, etc., it will have an `id` of
 * the `id` prop plus `-label`.
 */
export function FieldRow({ children, label, id, icon = null }: Props) {
  return (
    <div className="flex items-center justify-between py-4">
      <div>
        <label
          className="text-base text-blue-900 flex flex-col-reverse sm:flex-row"
          id={`${id}-label`}
          htmlFor={id}
        >
          {label}
          {icon}
        </label>
      </div>
      <div>{children}</div>
    </div>
  );
}
